<template>
    <span class="l-spinner">
        <b-spinner label="Uploading"></b-spinner>
    </span>
</template>

<script>
export default {
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped>
.l-spinner >>> .spinner-border {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: text-bottom;
    border: 0.25em solid;
    border-right: 0.25em solid transparent;
    border-radius: 50%;
    border-width: 0.2em;
    animation: spinner-border 0.75s linear infinite;
}
.l-spinner >>> .spinner-border-sm {
    width: 1rem;
    height: 1rem;
}

@keyframes spinner-border {
    100% {
        transform: rotate(1turn);
    }
}
</style>
